import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Nav=()=>{
    return (
        <StyledNav>
            <div className="left">Aryan</div>
            <div className="right">
                <ul>
                    <li><Link className="link" to="/"> About me </Link></li>
                    <li><Link className="link" to="/projects">Projects</Link></li>
                    <li><Link className="link" to="/blogs">Blogs</Link></li>
                    <li><Link className="link" to="/contactme">Contact me</Link></li>
                </ul>
            </div>
            <div className="burger">
                <div className="line-1"></div>
                <div className="line-2"></div>
            </div>
        </StyledNav>
    );
}

const StyledNav=styled.nav`

color:white;
position: sticky;
top:0;
font-weight:800;
box-sizing:border-box;
background-color: #8B73FF;
padding:0rem  0.8rem;
display:flex;
align-items: center;
justify-content: space-between;
height:12vh;
z-index: 1;
.link{
    text-decoration: none;
    color:white;
}
.right ul{
    display:flex;
}
li{
    list-style: none;
    margin: 0rem 1.8rem;
    cursor: pointer;
}
.burger{
    display: none;
}
.line-1,.line-2{
    width:2rem;
    height: 4px;
    background-color: white;
    margin:0.4rem 1rem;
}
.left{
    padding:1rem;
}
@media screen and (max-width:768px){
    padding:0rem 0.2rem ;
    font-weight:200;
    li{
        margin:0rem 0.2rem;
    }
    .burger{
        display: block;
        cursor: pointer;
    }
    .right{
    display: none;

    }
} 

`
export default Nav;